import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setCourseTeachersLoading,
    setCourseTeachers,
    setCourseTeachersError,
} from "../reducers/getCourseTeachersReducer";

const getCourseTeachers =
    (courseId: string | number, token: string) => async (dispatch: Dispatch) => {
        dispatch(setCourseTeachersLoading(true));
        dispatch(setCourseTeachersError(null));

        try {
            const result = await api.get(`courses/${courseId}/add-teacher/`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
            });

            const data = result?.data;
            const list = Array.isArray(data) ? data : data?.data ?? data?.teachers ?? [];
            dispatch(setCourseTeachers(list));
        } catch (error: any) {
            const message =
                error?.response?.data?.detail ||
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "Failed to load teachers.";
            dispatch(setCourseTeachersError(message));
        }
    };

export { getCourseTeachers };
export { resetCourseTeachers } from "../reducers/getCourseTeachersReducer";
